import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import ReactDOM from "react-dom"; // Added for Portal
import weeklyStyles from "../EventShiftsView/WeeklyCalendarSchedular.module.scss";
import { withTranslation } from "react-i18next";
import {
  encodeId,
  isMobileTab,
  titleWordLimit,
  handleError,
  handleSuccess,
} from "utils";
import * as moment from "moment";
import {
  getSchedularNotes,
  deleteSchedularNote,
  getEventListForAssigner,
  duplicateSchedulerEvent,
  eventPublished,
  getAssignedEmployess,
  useCreateUpdateSchedulerEventMutation,
  getEventListDetails,
} from "repositories/scheduler-repository";
import { buildDuplicateSchedulerEventPayload } from "./duplicateSchedulerEvent.utils";
import { useMultipleDuplicatesFlyout } from "./useMultipleDuplicatesFlyout";
import { useAssignUsersFromCard } from "./useAssignUsersFromCard";
import toast from "react-hot-toast";
import Loader from "components/Loader";
import { useHistory, useLocation } from "react-router-dom";
import { showTime } from "..";
import EmptySchedulerCellAdd from "accountOwner/pages/Scheduler/components/EmptySchedulerCellAdd";
import constants, {
  getSchedulerStatusById,
} from "../../../../../../../constants";
import PublishEventModal from "accountOwner/pages/Scheduler/components/Modals/PublishEvent";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Row,
} from "reactstrap";
import { ThreeDots, ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import {
  renderOfficeNameOrEnterprise,
  setterCustomSchduler,
  setterPublishOffices,
  matchedBothPatternValues,
  matchedBothDatesValues,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import EditOptionsModal, {
  editTypesVariables,
} from "accountOwner/pages/EditEvent/EditOptionsModal";
import HolidayImage from "assets/images/early_on.svg";
import Text from "components/Text";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import styles from "../../../../Scheduler.module.scss";
import {
  canShowEventCardMenu,
  isSchedulerAllDaySlotEvent,
  isSchedulerTimedSlotEvent,
} from "accountOwner/pages/Scheduler/scheduler.function";
import { NoteView } from "./EventsShiftsMonthly";
import AddNotesModal from "../Modals/AddNotesModal";
import EditNotesModal from "../Modals/EditNotesModal";
import DeleteNotes from "../Modals/DeleteNotes";
import {
  canDragSchedulerEventWithUnassigned,
  isUnassignedSchedulerEvent,
} from "./unassignedEvents.utils";
import {
  collectDraftPublishItemsFromEvents,
  filterEventsWorkspaceBySearch,
  shouldApplyEventsWorkspaceSearch,
} from "./eventsWorkspacePublish.utils";
import { collectClearableItemsFromEvents } from "./eventsWorkspaceClear.utils";
import { useSimpleEventCardDelete } from "./useSimpleEventCardDelete";
import {
  getEventShiftSelectionKey,
  isEventShiftSelected,
} from "./eventWeeklyLayout.constants";

const HOUR_HEIGHT = 80;

const getEventThemeClass = (event) => {
  const title = event.title?.toLowerCase() || "";
  if (title.includes("call patients") || title.includes("follow-up"))
    return "theme-blue";
  return "theme-green";
};

function EventsShiftsDaily({
  t,
  settotalEvents,
  currentDate,
  calendarView,
  selectedOfficeFilter,
  searchValue,
  upDateListonApply,
  handleSidebarToggle,
  isSidebarActive,
  viewSettingFilter = [],
  canAddShift,
  eventShiftFilter = [],
  isEnterpriseFilterActive = false,
  appliedPublishedDraftFilter = [],
  selectedEmpFilter = [],
  holidaysObject,
  setcurrentDate,
  onVisibleDraftEventsUpdate,
  onVisibleClearableItemsUpdate,
  bulkSelectMode,
  selectedEvents,
  handleEventSelectionToggle,
  handleSelectableEventsUpdate,
}) {
  const {
    effectiveOwnerId: selectedOwnerId,
    profile,
    effectiveOwnerIdString,
    isOwner,
    isStaff,
    dataAccessValues,
  } = useAccountOwnerCommon();
  const history = useHistory();
  const { search } = useLocation();
  const createSchedulerEventMutation = useCreateUpdateSchedulerEventMutation();
  const popupRef = useRef(null); // Ref for the popup element
  const scrollContainerRef = useRef(null);
  const headerRef = useRef(null);
  const divRef = useRef(null);

  const {
    openEventMenuKey,
    closeEventMenuAndFlyout,
    createEventMenuToggleHandler,
    handleMultipleDuplicatesClick,
    renderMultipleDuplicatesFlyout,
  } = useMultipleDuplicatesFlyout({
    scrollContainerRef,
    menuStyles: styles,
    dropdownToggleSelector: `.${weeklyStyles["interactive-events-dropdown"]}`,
  });

  const canEditAndViewOthersData = useCallback(
    (officeId) => {
      if (isStaff) {
        return (
          dataAccessValues?.officeList?.some(
            (res) => res.officeId === officeId && res.isAdmin,
          ) || false
        );
      }
      return isOwner;
    },
    [isStaff, isOwner, dataAccessValues?.officeList],
  );

  const [isAddNotesModal, setIsAddNotesModal] = useState({
    visible: false,
    date: "",
    value: "",
  });
  const [deleteConfirmation, setdeleteConfirmation] = useState({
    visible: false,
    id: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isEventLoading, setIsEventLoading] = useState(false);
  const [isPublishEventModalOpen, setIsPublishEventModalOpen] = useState(false);
  const [isEditNotesModal, setIsEditNotesModal] = useState({ visible: false });
  const [dayData, setDayData] = useState({
    date: moment().format("YYYY-MM-DD"),
    schedulerEvents: [],
  });
  const [eventCountCopy, setEventCountCopy] = useState(0);
  const [isDraftPublistEventOpen, setIsDraftPublishEvetntOpen] =
    useState(false);
  const [noOfEmployeeAssigne, setNoOfEmployeeAssigne] = useState(0);
  const [eventId, seteventId] = useState("");
  const [draggedEvent, setDraggedEvent] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragPreviewPosition, setDragPreviewPosition] = useState(null);
  const [editModalConfirmation, setEditModalConfirmation] = useState(false);
  const [pendingDragUpdate, setPendingDragUpdate] = useState(null);
  const [isDragDropLoading, setIsDragDropLoading] = useState(false);
  const [isEmpPopActive, setEmpPopupActive] = useState("");

  // State for dynamic table height calculation
  const [tableHeight, setTableHeight] = useState("auto");

  const dateMatchForHighlight = useMemo(() => {
    const searchValue = new URLSearchParams(search).get(showTime);
    if (searchValue?.includes("NaN") || !search) {
      return null;
    }
    return new Date(+searchValue);
  }, [search]);

  const highlightCheck = useMemo(() => {
    if (!dateMatchForHighlight || !currentDate) return false;
    return moment(dateMatchForHighlight)
      .startOf("day")
      .isSame(moment(currentDate).startOf("day"));
  }, [dateMatchForHighlight, currentDate]);

  // --- START OF DYNAMIC HEIGHT CALCULATION ---
  useEffect(() => {
    const calculateDynamicHeight = () => {
      if (scrollContainerRef.current) {
        const rect = scrollContainerRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Using exactly the same proven logic from previous components
        const wrapper =
          scrollContainerRef.current.closest(".scheduler-tabs") ||
          scrollContainerRef.current.closest(".Dashboard_box") ||
          document.body;

        let limitBottom = viewportHeight;

        if (wrapper) {
          const wrapperRect = wrapper.getBoundingClientRect();
          if (wrapperRect.bottom < viewportHeight) {
            limitBottom = wrapperRect.bottom - 5;
          }
        }

        let computedHeight = limitBottom - rect.top - 20;

        if (computedHeight < 200) computedHeight = 200;

        setTableHeight(`${computedHeight}px`);
      }
    };

    // Calculate on mount and shortly after
    calculateDynamicHeight();
    const timeoutId = setTimeout(calculateDynamicHeight, 150);

    // Attach listeners
    window.addEventListener("resize", calculateDynamicHeight);
    window.addEventListener("scroll", calculateDynamicHeight, {
      passive: true,
    });

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", calculateDynamicHeight);
      window.removeEventListener("scroll", calculateDynamicHeight);
    };
  }, []);
  // --- END OF DYNAMIC HEIGHT CALCULATION ---

  const hours = useMemo(() => {
    const hourList = [];
    for (let i = 0; i <= 23; i++) {
      const hour = moment().hour(i).minute(0);
      hourList.push({
        label: hour.format("h A"),
        moment: hour,
        hour: i,
      });
    }
    return hourList;
  }, []);

  useEffect(() => {
    if (!isLoading) getNotes(currentDate);
    // eslint-disable-next-line
  }, [currentDate, selectedOwnerId, calendarView, upDateListonApply]);

  useEffect(() => {
    if (isMobileTab() && isSidebarActive)
      handleSuccess(t("accountOwner.dateApply"));
    // eslint-disable-next-line
  }, [currentDate]);

  // UseEffect to scroll/focus on the popup when it opens
  useEffect(() => {
    if (isEmpPopActive?.id && popupRef.current) {
      popupRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  }, [isEmpPopActive]);

  const getNotes = async (_currentDate) => {
    try {
      setIsLoading(true);
      const selectedDate = moment(_currentDate).format("YYYY-MM-DD");
      let response = await getSchedularNotes(
        selectedDate,
        selectedDate,
        selectedOwnerId,
      );
      getEventListingForAssigner(
        selectedDate,
        selectedDate,
        response.data || [],
      );
    } catch (e) {
      handleError(e);
    }
    setIsLoading(false);
  };

  const { isAssignLoading, openAssignUsersModal, renderAssignUsersModals } =
    useAssignUsersFromCard({
      t,
      ownerId: selectedOwnerId,
      canAddShift,
      isStaff,
      onSuccess: () => getNotes(currentDate),
    });

  const getEventListingForAssigner = async (
    selectedStartDate,
    selectedEndDate,
    notesArray,
  ) => {
    try {
      setIsEventLoading(true);
      let response = await getEventListForAssigner(
        selectedOwnerId,
        selectedStartDate,
        selectedEndDate,
        selectedOfficeFilter,
        selectedEmpFilter,
      );
      let eventsDates = response?.data || [];

      const foundDay = eventsDates.find(
        (item) => dateFormater(item.date) === selectedStartDate,
      ) || { date: selectedStartDate, schedulerEvents: [] };

      if (notesArray?.length) {
        notesArray.forEach((note) => {
          if (dateFormater(foundDay.date) === dateFormater(note.date)) {
            foundDay.note = true;
            foundDay.data = note;
          }
        });
      }

      settotalEvents(foundDay.schedulerEvents?.length || 0);
      setEventCountCopy(foundDay.schedulerEvents?.length || 0);
      setDayData(foundDay);

      if (isMobileTab() && isSidebarActive && selectedOfficeFilter?.length) {
        handleSidebarToggle();
      }
    } catch (e) {
      handleError(e.message);
    }
    setIsEventLoading(false);
  };

  const onDuplicateEvent = async (event, requestedDate, count = 1) => {
    try {
      setIsLoading(true);
      await duplicateSchedulerEvent(
        buildDuplicateSchedulerEventPayload({
          schedulerEventId: event?.id,
          eventDate: requestedDate,
          duplicateCount: count,
        }),
      );
      handleSuccess(t("scheduler.duplicateSuccess"));
      closeEventMenuAndFlyout();
      getNotes(currentDate);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const { handleCardDeleteClick, renderSimpleDeleteConfirmModal } =
    useSimpleEventCardDelete({
      t,
      history,
      effectiveOwnerIdString,
      onSuccess: () => getNotes(currentDate),
    });

  const dateFormater = (date) => moment(date).format("YYYY-MM-DD");

  const changeDate = (direction) => {
    const newDate =
      direction === "next"
        ? moment(currentDate).add(1, "days").toDate()
        : moment(currentDate).subtract(1, "days").toDate();

    if (setcurrentDate) {
      setcurrentDate(newDate);
    }
  };

  const getTimeInMinutes = (time) => {
    if (!time) return 0;
    const date = new Date(time);
    if (isNaN(date.getTime())) return 0;
    return date.getHours() * 60 + date.getMinutes();
  };

  /**
   * True when a timed event/shift overlaps the given hour slot [hour, hour+1).
   * @param {Array<object>} events
   * @param {number} hourIndex
   */
  const hourSlotHasEvent = (events, hourIndex) => {
    const slotStart = hourIndex * 60;
    const slotEnd = slotStart + 60;
    return (events || []).some((event) => {
      const startMin = getTimeInMinutes(event.startTime);
      const endMin = getTimeInMinutes(event.endTime);
      return startMin < slotEnd && endMin > slotStart;
    });
  };

  const snapTo15Minutes = useCallback((minutes) => {
    const snapped = Math.round(minutes / 15) * 15;
    return Math.max(0, Math.min(59, snapped));
  }, []);

  const calculateOverlapPositions = useCallback((events) => {
    if (!events || events.length === 0) return [];

    const sortedEvents = [...events].sort((a, b) => {
      const startA = getTimeInMinutes(a.startTime);
      const startB = getTimeInMinutes(b.startTime);
      if (startA !== startB) return startA - startB;
      const durA = getTimeInMinutes(a.endTime) - startA;
      const durB = getTimeInMinutes(b.endTime) - startB;
      return durB - durA;
    });

    const positions = [];
    const columns = [];

    sortedEvents.forEach((event) => {
      const start = getTimeInMinutes(event.startTime);
      const end = getTimeInMinutes(event.endTime);

      let colIndex = 0;
      while (true) {
        const col = columns[colIndex];
        if (!col) {
          columns[colIndex] = [event];
          break;
        }
        const isOverlapping = col.some((placedEvent) => {
          const pStart = getTimeInMinutes(placedEvent.startTime);
          const pEnd = getTimeInMinutes(placedEvent.endTime);
          return start < pEnd && end > pStart;
        });

        if (!isOverlapping) {
          col.push(event);
          break;
        }
        colIndex++;
      }

      positions.push({ event, colIndex });
    });

    return positions.map(({ event, colIndex }) => ({
      event,
      widthFactor: 1 / columns.length,
      leftOffsetFactor: colIndex / columns.length,
    }));
  }, []);

  const getFilteredEvents = () => {
    if (!dayData?.schedulerEvents) return [];

    let events = [...dayData.schedulerEvents];

    if (shouldApplyEventsWorkspaceSearch(searchValue)) {
      events = filterEventsWorkspaceBySearch(events, searchValue);
    }

    if (eventShiftFilter?.length) {
      const eventsFilter = eventShiftFilter.includes("event");
      const shiftFilter = eventShiftFilter.includes("shift");
      const shiftByOtherFilter = eventShiftFilter.includes("shift-others");
      events = events.filter((ev) => {
        if (eventsFilter && !ev.isShift) return true;
        if (
          shiftFilter &&
          ev.isShift &&
          (shiftByOtherFilter || ev.createdById === profile.id)
        )
          return true;
        if (shiftByOtherFilter && ev.isShift && ev.createdById !== profile.id)
          return true;
        return false;
      });
    }

    if (appliedPublishedDraftFilter?.length) {
      events = events.filter((ev) => {
        if (appliedPublishedDraftFilter.includes("published") && !ev.isDraft)
          return true;
        if (appliedPublishedDraftFilter.includes("draft") && ev.isDraft)
          return true;
        return false;
      });
    }

    if (isEnterpriseFilterActive) {
      events = events.filter((e) => e.isEnterprise === true);
    }

    return events;
  };

  const canDragEvent = useCallback(
    (eventItem) => {
      const baseCanDrag = (item) => {
        const createdByMe = item.createdById === profile?.id;
        const createdByOthers =
          item?.isShift && profile?.id !== item?.createdById;

        if (item?.isShift) {
          if (createdByMe) {
            return true;
          }
          if (createdByOthers) {
            const isAdmin = profile?.isAdmin;
            const isAccountOwner =
              profile && profile?.role
                ? profile.role.systemRole === constants.systemRoles.accountOwner
                : false;
            if (isAccountOwner || isAdmin) {
              return true;
            }
          }
          return false;
        }

        if (
          item.agendaType === constants.agendaType.EVENT ||
          !item.agendaType
        ) {
          return createdByMe;
        }

        return false;
      };

      return canDragSchedulerEventWithUnassigned(eventItem, baseCanDrag);
    },
    [profile?.id, selectedOwnerId],
  );

  const isAllDayEvent = useCallback((eventItem) => {
    return (
      eventItem.isAllDayEvent ||
      eventItem.isAllDayBusy ||
      !eventItem.startTime ||
      !eventItem.endTime
    );
  }, []);

  const getTimeRange = useCallback(() => {
    const minHour = hours.length > 0 ? hours[0].hour : 0;
    const maxHour = hours.length > 0 ? hours[hours.length - 1].hour : 23;
    return {
      startTime: moment().hour(minHour).minute(0).second(0),
      endTime: moment().hour(maxHour).minute(59).second(59),
    };
  }, [hours]);

  const isTimeWithinRange = useCallback((timeMoment, timeRange, baseDate) => {
    if (!timeMoment || !timeRange) return true;

    if (baseDate && !timeMoment.isSame(baseDate, "day")) {
      return false;
    }

    const timeInMinutes = timeMoment.hour() * 60 + timeMoment.minute();
    const rangeStartMinutes =
      timeRange.startTime.hour() * 60 + timeRange.startTime.minute();
    const rangeEndMinutes =
      timeRange.endTime.hour() * 60 + timeRange.endTime.minute();

    return (
      timeInMinutes >= rangeStartMinutes && timeInMinutes <= rangeEndMinutes
    );
  }, []);

  const calculateNewDateTime = useCallback(
    (eventItem, dropX, dropY, cellElement, hourIndex) => {
      if (
        !cellElement ||
        hourIndex < 0 ||
        hourIndex >= hours.length ||
        !eventItem
      ) {
        return null;
      }

      const cellRect = cellElement.getBoundingClientRect();
      const relativeY = dropY - cellRect.top;
      const cellHeight = cellRect.height;
      const minuteHeight = cellHeight / 60;
      const minutesFromHourStart = relativeY / minuteHeight;
      const exactMinutes = Math.round(minutesFromHourStart);
      const clampedMinute = snapTo15Minutes(exactMinutes);

      const viewDateStr = moment(currentDate).format("YYYY-MM-DD");
      const newDate = moment(viewDateStr);
      const newStartTime = moment(newDate)
        .hour(hourIndex)
        .minute(clampedMinute)
        .second(0);

      const timeRange = getTimeRange();

      if (!eventItem.startTime || !eventItem.endTime) {
        const durationMinutes = 60;
        const newEndTime = moment(newStartTime).add(durationMinutes, "minutes");

        if (
          !isTimeWithinRange(newStartTime, timeRange, newDate) ||
          !isTimeWithinRange(newEndTime, timeRange, newDate)
        ) {
          return { error: "timeRangeExceeded" };
        }

        return {
          newDate: newDate.toDate(),
          newStartTime: newStartTime.toDate(),
          newEndTime: newEndTime.toDate(),
          newStartTimeString: newStartTime.format("YYYY-MM-DDTHH:mm"),
          newEndTimeString: newEndTime.format("YYYY-MM-DDTHH:mm"),
        };
      }

      const originalStart = moment(eventItem.startTime);
      const originalEnd = moment(eventItem.endTime);
      const durationMinutes = originalEnd.diff(originalStart, "minutes");

      const newEndTime = moment(newStartTime).add(durationMinutes, "minutes");

      if (
        !isTimeWithinRange(newStartTime, timeRange, newDate) ||
        !isTimeWithinRange(newEndTime, timeRange, newDate)
      ) {
        return { error: "timeRangeExceeded" };
      }

      // Daily view: we only show one day, so drop is always on that day - no same-day check needed
      return {
        newDate: newDate.toDate(),
        newStartTime: newStartTime.toDate(),
        newEndTime: newEndTime.toDate(),
        newStartTimeString: newStartTime.format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: newEndTime.format("YYYY-MM-DDTHH:mm"),
      };
    },
    [currentDate, hours, getTimeRange, isTimeWithinRange, snapTo15Minutes],
  );

  const calculateNewDateForAllDay = useCallback(
    (eventItem, originalDateString = null) => {
      const newDate = moment(currentDate).startOf("day");

      let originalDate = null;
      if (originalDateString) {
        originalDate = moment(originalDateString).startOf("day");
      } else if (eventItem.date) {
        originalDate = moment(eventItem.date).startOf("day");
      } else if (eventItem.startTime) {
        originalDate = moment(eventItem.startTime).startOf("day");
      }

      if (originalDate && newDate.isSame(originalDate, "day")) {
        return null;
      }

      return {
        newDate: newDate.toDate(),
        newStartTime: newDate.startOf("day").toDate(),
        newEndTime: newDate.endOf("day").toDate(),
        newStartTimeString: newDate.startOf("day").format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: newDate.endOf("day").format("YYYY-MM-DDTHH:mm"),
      };
    },
    [currentDate],
  );

  const getTimeCheck = useCallback((alreadyTime, selectedTime) => {
    if (alreadyTime) {
      const selectedStartTime = moment(selectedTime);
      const alreadySelectedStartTime = moment(alreadyTime);
      if (
        selectedStartTime.hour() !== alreadySelectedStartTime.hour() ||
        selectedStartTime.minute() !== alreadySelectedStartTime.minute()
      ) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }, []);

  const performEventUpdate = useCallback(
    async (eventData, newDateTime, editType, originalRequestedDate = null) => {
      if (!newDateTime || !eventData) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      const requestedDateForCheck = originalRequestedDate
        ? originalRequestedDate
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DD")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DD")
            : moment(eventData.date || newDateTime.newDate).format(
                "YYYY-MM-DD",
              );

      const dateChangedResult = matchedBothDatesValues({
        eventDetail: eventData,
        repeatedEndDate: eventData.repeatedEndDate
          ? moment(eventData.repeatedEndDate).toDate()
          : moment().add(3, "month").toDate(),
        requestedDate: requestedDateForCheck,
        eventDate: newDateTime.newDate,
      });

      const startTimeChanged = getTimeCheck(
        eventData.startTime,
        newDateTime.newStartTimeString,
      );
      const endTimeChanged = getTimeCheck(
        eventData.endTime,
        newDateTime.newEndTimeString,
      );

      const originalRequestedDateForParams = originalRequestedDate
        ? moment(originalRequestedDate).format("YYYY-MM-DDTHH:mm")
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DDTHH:mm")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DDTHH:mm")
            : moment(newDateTime.newDate).format("YYYY-MM-DDTHH:mm");

      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : eventData.requestedDate
          ? moment(eventData.requestedDate).toDate()
          : eventData.startTime
            ? moment(eventData.startTime).toDate()
            : null;

      const eventDate = moment(newDateTime.newDate).toDate();

      const params = {
        SchedulerEventId: eventData.id,
        OwnerId: selectedOwnerId,
        Title: eventData.title,
        Date: moment(
          requestedDateForDateCalc &&
            moment(requestedDateForDateCalc)
              .startOf("day")
              .isSame(moment(eventDate).startOf("day"))
            ? eventData?.date
            : eventDate,
        ).format("YYYY-MM-DDTHH:mm"),
        StartTime: newDateTime.newStartTimeString,
        EndTime: newDateTime.newEndTimeString,
        IsAllDayEvent: eventData.isAllDayEvent || false,
        RepeatedType: eventData.repeatedType || 1,
        RepeatedDay: moment(newDateTime.newDate).isoWeekday(),
        RepeatedEndDate:
          eventData.repeatedType > 1 && eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).format("YYYY-MM-DD")
            : null,
        Location: eventData.location || "",
        BlockForPatient: eventData.blockForPatient || false,
        Note: eventData.note || "",
        PublishAsEvent: eventData.publishAsEvent || false,
        eventEmployees: Array.isArray(eventData.eventEmployees)
          ? eventData.eventEmployees
          : [],
        EventRoles: Array.isArray(eventData.eventRoles)
          ? eventData.eventRoles
          : [],
        EventTags: Array.isArray(eventData.eventTags)
          ? eventData.eventTags
          : [],
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        ReminderBeforeInMins: eventData.reminderBeforeInMins || 0,
        isDraft: eventData.isDraft || false,
        requestedDate: originalRequestedDateForParams,
        timezoneCode: eventData.timezoneCode || moment.tz.guess(),
        EditType: editType || editTypesVariables.allEvent,
        UpdateFlags: {
          isTitleEdit: false,
          isStartTimeEdit: startTimeChanged,
          isEndTimeEdit: endTimeChanged,
          isAllDayEventEdit: false,
          isNoteEdit: false,
          isLocationEdit: false,
          isReminderBeforeInMinsEdit: false,
          isEnterpriseEdit: false,
          isOfficeIdEdit: false,
          EmployeeIds: [],
          RoleIds: [],
          IsRepeatTypeChange: false,
          IsEventDateChange: false,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
          IsBlockForPatientChange: false,
          tagsIds: false,
        },
      };

      if (eventData.isShift) {
        params.Title = eventData.title || "";
        delete params.Location;
        delete params.Note;
        if (
          Array.isArray(eventData.eventEmployees) &&
          eventData.eventEmployees.length > 0 &&
          eventData.eventEmployees[0]
        ) {
          params.officeId = eventData.eventEmployees[0].officeId || null;
        }
      } else {
        params.IsAutoApprove = eventData.isAutoApprove || false;
      }

      try {
        setterCustomSchduler({
          params,
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      try {
        const preferredOption = {
          dropdown: eventData.publishAsEvent
            ? [{ id: "allowInvitees" }]
            : eventData.isDraft
              ? [{ id: "saveDraft" }]
              : [{ id: "inviteesOnly" }],
          otherOptions: [],
        };
        setterPublishOffices({
          preferredOption,
          userIds: Array.isArray(eventData.eventEmployees)
            ? eventData.eventEmployees
            : [],
          publishAsEvent: eventData.publishAsEvent
            ? "allowInvitees"
            : eventData.isDraft
              ? "saveDraft"
              : "inviteesOnly",
          nonInviteesPublish: eventData.publishedType || "allOffices",
          params,
          officeIdForNonInvitee: Array.isArray(
            eventData.schedulerEventPublishedOffices,
          )
            ? eventData.schedulerEventPublishedOffices.filter(
                (office) => office && office.id,
              )
            : [],
          edit: true,
          isDraft: eventData.isDraft || false,
        });
      } catch (error) {
        console.warn("Error in setterPublishOffices:", error);
      }

      await createSchedulerEventMutation.mutateAsync(params);

      // Refresh the event list
      getNotes(currentDate);

      toast.success(t("staff.eventUpdated"));
    },
    [
      selectedOwnerId,
      createSchedulerEventMutation,
      t,
      getTimeCheck,
      currentDate,
    ],
  );

  const updateEventAfterDrag = useCallback(
    async (eventItem, newDateTime, editType = null) => {
      if (!newDateTime || !eventItem || !eventItem.id) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        const originalRequestedDate = moment(
          currentDate || eventItem.startTime || newDateTime.newDate,
        ).format("YYYY-MM-DD");
        const eventDetails = await getEventListDetails(
          eventItem.id,
          originalRequestedDate,
        );
        const eventData = eventDetails?.data;

        if (!eventData) {
          toast.error(t("scheduler.eventNotFound"));
          return;
        }

        const dateChangedResult = matchedBothDatesValues({
          eventDetail: eventData,
          repeatedEndDate: eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).toDate()
            : moment().add(3, "month").toDate(),
          requestedDate: originalRequestedDate,
          eventDate: newDateTime.newDate,
        });

        const repeatedOptionChanged = matchedBothPatternValues({
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });

        const anyChangedForDate = repeatedOptionChanged;

        const startTimeChanged = getTimeCheck(
          eventData.startTime,
          newDateTime.newStartTimeString,
        );
        const endTimeChanged = getTimeCheck(
          eventData.endTime,
          newDateTime.newEndTimeString,
        );

        const hasChanges =
          dateChangedResult.startDateChanged ||
          dateChangedResult.endDateChanged ||
          startTimeChanged ||
          endTimeChanged;

        const neverCheck =
          eventData.repeatedType ===
          addEditEventsConst.repeatedOptionsValues.never;
        if (!neverCheck && eventData.repeatedEndDate) {
          const newDateStr = moment(newDateTime.newDate).format("YYYY-MM-DD");
          const repeatedEndDateStr = moment(eventData.repeatedEndDate).format(
            "YYYY-MM-DD",
          );
          if (
            !moment(newDateStr).isBefore(repeatedEndDateStr) &&
            newDateStr !== repeatedEndDateStr
          ) {
            toast.error(t("form.errors.endGreater"));
            return;
          }
        }

        const isNotDrafted = !eventData.isDraft;

        if (!neverCheck && !editType && hasChanges && isNotDrafted) {
          setPendingDragUpdate({
            eventData,
            newDateTime,
            anyChangedForDate,
            originalRequestedDate,
          });
          setEditModalConfirmation(true);
          return;
        }

        let finalEditType = editType;
        if (!finalEditType) {
          if (neverCheck) {
            finalEditType = editTypesVariables.allEvent;
          } else {
            finalEditType = editTypesVariables.allEvent;
          }
        }

        await performEventUpdate(
          eventData,
          newDateTime,
          finalEditType,
          originalRequestedDate,
        );
      } catch (error) {
        toast.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },
    [t, getTimeCheck, performEventUpdate, currentDate],
  );

  const handleDragStart = useCallback(
    (e, eventItem, originalDateKey = null) => {
      if (!canDragEvent(eventItem)) {
        e.preventDefault();
        return;
      }

      let originalDate = null;
      if (originalDateKey) {
        const parsedDate = moment(originalDateKey, "ddd, MMM DD, YYYY");
        if (parsedDate.isValid()) {
          const currentYear = moment().year();
          originalDate = parsedDate.year(currentYear).startOf("day");
        }
      }

      if (!originalDate) {
        if (eventItem.date) {
          originalDate = moment(eventItem.date).startOf("day");
        } else if (eventItem.startTime) {
          originalDate = moment(eventItem.startTime).startOf("day");
        }
      }

      setDraggedEvent({
        eventItem,
        originalDate: originalDate ? originalDate.format("YYYY-MM-DD") : null,
      });
      setIsDragging(true);

      const rect = e.currentTarget.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      const dragImage = e.currentTarget.cloneNode(true);
      dragImage.style.opacity = "0";
      dragImage.style.position = "absolute";
      dragImage.style.top = "-1000px";
      document.body.appendChild(dragImage);
      e.dataTransfer.setDragImage(dragImage, offsetX, offsetY);
      setTimeout(() => document.body.removeChild(dragImage), 0);
    },
    [canDragEvent],
  );

  const handleDragOver = useCallback(
    (e, hourIndex, isAllDayRow = false) => {
      if (!draggedEvent) {
        e.preventDefault();
        return;
      }

      const { eventItem } = draggedEvent;
      const isDraggedAllDay = isAllDayEvent(eventItem);

      if (isDraggedAllDay && !isAllDayRow) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        setDragPreviewPosition(null);
        return;
      }
      if (!isDraggedAllDay && isAllDayRow) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        setDragPreviewPosition(null);
        return;
      }

      e.preventDefault();
      e.dataTransfer.dropEffect = "move";

      if (!isAllDayRow && !isDraggedAllDay && hourIndex !== undefined) {
        const cellElement = e.currentTarget;
        const cellRect = cellElement.getBoundingClientRect();
        const relativeY = e.clientY - cellRect.top;
        const cellHeight = cellRect.height;
        const minuteHeight = cellHeight / 60;
        const minutesFromHourStart = relativeY / minuteHeight;
        const exactMinutes = Math.round(minutesFromHourStart);
        const clampedMinute = snapTo15Minutes(exactMinutes);

        const originalStart = moment(eventItem.startTime);
        const originalEnd = moment(eventItem.endTime);
        const durationMinutes = originalEnd.diff(originalStart, "minutes");

        const topPercent = (clampedMinute / 60) * 100;
        const heightPercent = (durationMinutes / 60) * 100;

        setDragPreviewPosition({
          hourIndex,
          topPercent,
          heightPercent,
          clampedMinute,
        });
      } else if (isAllDayRow && isDraggedAllDay) {
        setDragPreviewPosition({
          isAllDay: true,
        });
      }
    },
    [draggedEvent, isAllDayEvent, snapTo15Minutes],
  );

  const handleDrop = useCallback(
    async (e, hourIndex) => {
      e.preventDefault();
      if (!draggedEvent || !draggedEvent.eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const { eventItem } = draggedEvent;

      if (!eventItem || !eventItem.id) {
        toast.error("Invalid event data");
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const cellElement = e.currentTarget;
      const newDateTime = calculateNewDateTime(
        eventItem,
        e.clientX,
        e.clientY,
        cellElement,
        hourIndex,
      );

      if (newDateTime && newDateTime.error === "timeRangeExceeded") {
        toast.error("You can't move the event outside the time range");
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      if (!newDateTime) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      if (eventItem.startTime && newDateTime.newStartTime) {
        const originalStartTime = moment(eventItem.startTime);
        const newStartTime = moment(newDateTime.newStartTime);
        if (
          originalStartTime.hour() === newStartTime.hour() &&
          originalStartTime.minute() === newStartTime.minute()
        ) {
          setIsDragging(false);
          setDraggedEvent(null);
          setDragPreviewPosition(null);
          return;
        }
      }

      setIsDragDropLoading(true);
      try {
        await updateEventAfterDrag(eventItem, newDateTime);
      } catch (error) {
      } finally {
        setIsDragDropLoading(false);
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
      }
    },
    [
      draggedEvent,
      isAllDayEvent,
      calculateNewDateTime,
      calculateNewDateForAllDay,
      updateEventAfterDrag,
      t,
      currentDate,
    ],
  );

  const handleDragEnd = useCallback(() => {
    if (!isDragDropLoading) {
      setIsDragging(false);
      setDraggedEvent(null);
      setDragPreviewPosition(null);
    }
  }, [isDragDropLoading]);

  const toggleEmpPopup = useCallback(
    async (e, item, dayMoment) => {
      try {
        e.stopPropagation();
        const targetRect = e.currentTarget.getBoundingClientRect();

        setEmpPopupActive({});
        setIsLoading(true);
        const schedularEventDate = dayMoment.format("YYYY-MM-DD");
        const res = await getAssignedEmployess(
          item.id,
          schedularEventDate,
          selectedEmpFilter,
        );
        setEmpPopupActive({
          data: res.data || [],
          date: dayMoment.format("YYYY-MM-DDTHH:mm:ss"),
          id: item.id,
          position: {
            top: targetRect.bottom + window.scrollY,
            left: targetRect.left + window.scrollX,
          },
        });
      } catch (err) {
        handleError(err);
      }
      setIsLoading(false);
    },
    [selectedEmpFilter],
  );

  const filteredEvents = useMemo(
    () => getFilteredEvents(),
    [
      dayData,
      searchValue,
      eventShiftFilter,
      appliedPublishedDraftFilter,
      isEnterpriseFilterActive,
      profile?.id,
    ],
  );

  useEffect(() => {
    settotalEvents(filteredEvents.length);
  }, [filteredEvents.length, settotalEvents]);

  useEffect(() => {
    if (!handleSelectableEventsUpdate) return;
    const requestedDate = moment(currentDate).format("YYYY-MM-DD");
    const eventsMap = {};
    (filteredEvents || []).forEach((ev) => {
      const key = getEventShiftSelectionKey(ev.id, requestedDate);
      eventsMap[key] = {
        id: ev.id,
        date: requestedDate,
        isDraft: ev.isDraft,
        isShift: Boolean(ev.isShift),
        publishAsEvent: ev.publishAsEvent,
        userId: null,
        isUnassigned: isUnassignedSchedulerEvent(ev),
      };
    });
    handleSelectableEventsUpdate(eventsMap);
  }, [filteredEvents, currentDate, handleSelectableEventsUpdate]);

  const visibleDraftItemsForPublish = useMemo(
    () =>
      collectDraftPublishItemsFromEvents(
        filteredEvents,
        moment(currentDate).format("YYYY-MM-DD"),
      ),
    [filteredEvents, currentDate],
  );

  const visibleClearableItems = useMemo(
    () => collectClearableItemsFromEvents(filteredEvents),
    [filteredEvents],
  );

  useEffect(() => {
    if (!onVisibleDraftEventsUpdate) return;
    onVisibleDraftEventsUpdate(visibleDraftItemsForPublish);
  }, [visibleDraftItemsForPublish, onVisibleDraftEventsUpdate]);

  useEffect(() => {
    if (!onVisibleClearableItemsUpdate) return;
    onVisibleClearableItemsUpdate(visibleClearableItems);
  }, [visibleClearableItems, onVisibleClearableItemsUpdate]);

  const allDayEvents = filteredEvents.filter(isSchedulerAllDaySlotEvent);
  const timeGridEvents = filteredEvents.filter(isSchedulerTimedSlotEvent);
  const positionedEvents = calculateOverlapPositions(timeGridEvents);

  const dayMoment = moment(currentDate);
  const dayDateStr = dayMoment.format("DD-MM-YYYY");
  const existingHoliday = holidaysObject[dayDateStr];

  const renderEvent = (
    event,
    dynamicStyles,
    dayMoment,
    hourIndex = null,
    originalDateKey = null,
    isDragPreview = false,
  ) => {
    const themeClass = getEventThemeClass(event);
    const createdByOthers =
      event?.isShift && profile?.id !== event?.createdById;

    const canShowEventMenu =
      !isDragPreview &&
      canShowEventCardMenu(event, profile, {
        isOwner,
        canEditAndViewOthersData,
      });
    const eventMenuKey = `${event.id}_${dayMoment.format("YYYY-MM-DD")}_${
      event?.isAllDayEvent ? "allday" : "timed"
    }_${isDragPreview ? "preview" : "card"}`;
    const selectionDate = dayMoment.format("YYYY-MM-DD");
    const selectionKey = getEventShiftSelectionKey(event.id, selectionDate);
    const isEventSelected = isEventShiftSelected(
      selectedEvents,
      event.id,
      selectionDate,
    );

    const moveToDetailPage = (e) => {
      if (e.target.closest(".interactive-dropdown")) return;
      history.push({
        pathname: constants.routes.scheduler.eventDetails.replace(
          ":eventId",
          encodeId(event.id),
        ),
        state: { requestedDate: dayMoment.format("YYYY-MM-DD") },
        search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
      });
    };

    const canDrag = canDragEvent(event) && !bulkSelectMode;
    const isDragged =
      isDragging && draggedEvent?.eventItem?.id === event.id && !isDragPreview;

    return (
      <div
        key={event.id}
        className={`${weeklyStyles["event-card"]} ${weeklyStyles[themeClass]}${
          bulkSelectMode ? ` ${weeklyStyles["bulk-select-event-card"]}` : ""
        }`}
        style={{
          ...dynamicStyles,

          backgroundColor: event?.isDraft ? "#FEF3D7" : "",
          cursor: canDrag ? "grab" : "pointer",
          opacity: isDragged
            ? 0
            : dynamicStyles?.opacity !== undefined
              ? dynamicStyles.opacity
              : 1,
          zIndex: isDragged ? 1000 : 2,
        }}
        draggable={canDrag}
        onDragStart={(e) => handleDragStart(e, event, originalDateKey)}
        onDragEnd={handleDragEnd}
        onDragOver={(e) => {
          if (isDragging && draggedEvent && hourIndex !== null) {
            const dayColumnBody = e.currentTarget.closest(
              `.${weeklyStyles["day-column-body"]}`,
            );
            if (dayColumnBody) {
              const dayColumnRect = dayColumnBody.getBoundingClientRect();
              const relativeY = e.clientY - dayColumnRect.top;
              const calculatedHourIndex = Math.floor(relativeY / HOUR_HEIGHT);

              if (
                calculatedHourIndex >= 0 &&
                calculatedHourIndex < hours.length
              ) {
                e.preventDefault();
                e.stopPropagation();
                e.dataTransfer.dropEffect = "move";

                const hourStartY = calculatedHourIndex * HOUR_HEIGHT;
                const relativeYInHour = relativeY - hourStartY;
                const minuteHeight = HOUR_HEIGHT / 60;
                const minutesFromHourStart = relativeYInHour / minuteHeight;
                const exactMinutes = Math.round(minutesFromHourStart);
                const clampedMinute = snapTo15Minutes(exactMinutes);

                const { eventItem } = draggedEvent;
                const originalStart = moment(eventItem.startTime);
                const originalEnd = moment(eventItem.endTime);
                const durationMinutes = originalEnd.diff(
                  originalStart,
                  "minutes",
                );

                const topPercent = (clampedMinute / 60) * 100;
                const heightPercent = (durationMinutes / 60) * 100;

                setDragPreviewPosition({
                  hourIndex: calculatedHourIndex,
                  topPercent,
                  heightPercent,
                  clampedMinute,
                });
              }
            }
          }
        }}
        onDrop={(e) => {
          if (isDragging && draggedEvent && hourIndex !== null) {
            const dayColumnBody = e.currentTarget.closest(
              `.${weeklyStyles["day-column-body"]}`,
            );
            if (dayColumnBody) {
              const dayColumnRect = dayColumnBody.getBoundingClientRect();
              const relativeY = e.clientY - dayColumnRect.top;
              const calculatedHourIndex = Math.floor(relativeY / HOUR_HEIGHT);

              if (
                calculatedHourIndex >= 0 &&
                calculatedHourIndex < hours.length
              ) {
                e.preventDefault();
                e.stopPropagation();

                const gridLines = dayColumnBody.querySelectorAll(
                  `.${weeklyStyles["grid-line"]}`,
                );
                if (gridLines[calculatedHourIndex]) {
                  const newDateTime = calculateNewDateTime(
                    draggedEvent.eventItem,
                    e.clientX,
                    e.clientY,
                    gridLines[calculatedHourIndex],
                    calculatedHourIndex,
                  );

                  if (!newDateTime) {
                    setIsDragging(false);
                    setDraggedEvent(null);
                    setDragPreviewPosition(null);
                    return;
                  }

                  if (newDateTime.error) {
                    if (newDateTime.error === "timeRangeExceeded") {
                      toast.error(
                        t("You can't move the event outside the time range"),
                      );
                    }
                    setIsDragging(false);
                    setDraggedEvent(null);
                    setDragPreviewPosition(null);
                    return;
                  }

                  setIsDragDropLoading(true);
                  updateEventAfterDrag(draggedEvent.eventItem, newDateTime)
                    .catch(() => {})
                    .finally(() => {
                      setIsDragDropLoading(false);
                      setIsDragging(false);
                      setDraggedEvent(null);
                      setDragPreviewPosition(null);
                    });
                }
              }
            }
          }
        }}
        onClick={(e) => {
          if (isDragging) {
            e.stopPropagation();
            return;
          }
          if (e.target.closest(".interactive-dropdown")) return;
          if (bulkSelectMode) {
            handleEventSelectionToggle?.(selectionKey, {
              id: event.id,
              date: dayMoment.format("YYYY-MM-DD"),
              isDraft: event.isDraft,
              isShift: Boolean(event.isShift),
              publishAsEvent: event.publishAsEvent,
              userId: null,
              isUnassigned: isUnassignedSchedulerEvent(event),
            });
            return;
          }
          moveToDetailPage(e);
        }}
      >
        {bulkSelectMode && !isDragPreview && (
          <div
            className={`ch-checkbox ${styles["bulk-select-checkbox"]}`}
            onClick={(e) => e.stopPropagation()}
          >
            <label>
              <input
                type="checkbox"
                checked={isEventSelected}
                onChange={() =>
                  handleEventSelectionToggle?.(selectionKey, {
                    id: event.id,
                    date: dayMoment.format("YYYY-MM-DD"),
                    isDraft: event.isDraft,
                    isShift: Boolean(event.isShift),
                    publishAsEvent: event.publishAsEvent,
                    userId: null,
                    isUnassigned: isUnassignedSchedulerEvent(event),
                  })
                }
              />
              <span />
            </label>
          </div>
        )}
        <div
          className={weeklyStyles["badges-row"]}
          style={{ alignItems: "center", justifyContent: "space-between" }}
        >
          {(!viewSettingFilter.length || viewSettingFilter.includes("tag")) && (
            <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
              {event.isDraft && (
                <span
                  className={`${weeklyStyles["badge"]} ${styles["draft-warning-bg"]}`}
                >
                  DRAFT
                </span>
              )}
              <span
                className={`${weeklyStyles["badge"]} ${weeklyStyles["type-badge"]} ${event.isDraft ? styles["theme-green-bg"] : ""}`}
              >
                {themeClass === "theme-orange"
                  ? "BUSY"
                  : event.isShift
                    ? createdByOthers
                      ? t("scheduler.agenda.shiftByOthers")
                      : "SHIFT"
                    : "EVENT"}
              </span>
            </div>
          )}

          {canShowEventMenu && (
            <Dropdown
              isOpen={openEventMenuKey === eventMenuKey}
              toggle={createEventMenuToggleHandler(eventMenuKey)}
              className={`interactive-dropdown ${weeklyStyles["interactive-events-dropdown"]}`}
              onClick={(e) => e.stopPropagation()}
            >
              <DropdownToggle
                tag="div"
                className="cursor-pointer"
                style={{ lineHeight: 0 }}
              >
                <ThreeDots size={14} color="#6B7280" />
              </DropdownToggle>
              <DropdownMenu
                end
                container="body"
                className={styles["office-dropdown-menu"]}
              >
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDuplicateEvent(event, dayMoment, 1);
                  }}
                >
                  <span>
                    {t("scheduler.duplicateEvent", {
                      eventOrShiftOrLeave: event?.isShift
                        ? t("accountOwner.shiftTab")
                        : t("accountOwner.eventTab"),
                    })}
                  </span>
                </DropdownItem>
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  toggle={false}
                  onClick={handleMultipleDuplicatesClick(
                    eventMenuKey,
                    event,
                    dayMoment,
                  )}
                >
                  <span>{t("scheduler.multipleDuplicates")}</span>
                </DropdownItem>
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    openAssignUsersModal(event, dayMoment);
                  }}
                >
                  <span>{t("scheduler.assignStaff")}</span>
                </DropdownItem>
                {/* Intentionally commented out unassign users dropdown item for future use */}
                {/* <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    toast(
                      t("scheduler.actionComingSoon", {
                        action: t("scheduler.unassignUsers"),
                      }),
                    );
                  }}
                >
                  <span>{t("scheduler.unassignUsers")}</span>
                </DropdownItem> */}
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCardDeleteClick(
                      event,
                      dayMoment.format("YYYY-MM-DD"),
                      {
                        selectedUserIdsFromStaffView: event?.userId
                          ? [event.userId]
                          : [],
                        lockSelectedUsers: Boolean(event?.userId),
                      },
                      {
                        search: effectiveOwnerIdString
                          ? `?${effectiveOwnerIdString}`
                          : "",
                      },
                    );
                  }}
                >
                  <span style={{ color: "#EE4F4F" }}>
                    {t("scheduler.deleteEvent", {
                      eventOrShift: event?.isShift
                        ? t("accountOwner.shiftTab")
                        : t("accountOwner.eventTab"),
                    })}
                  </span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          )}
        </div>

        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("timeString")) && (
          <div className={weeklyStyles["event-date"]}>
            {event?.isAllDayEvent
              ? t("scheduler.agenda.allDayEvent")
              : event?.startTime && event?.endTime
                ? moment(event?.startTime).format("h:mm A") +
                  " - " +
                  moment(event?.endTime).format("h:mm A")
                : ""}
          </div>
        )}

        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("officeName")) && (
          <div className={weeklyStyles["event-office-name"]}>
            {renderOfficeNameOrEnterprise(event, t)}
          </div>
        )}

        {(!viewSettingFilter.length || viewSettingFilter.includes("title")) &&
          themeClass !== "theme-orange" && (
            <div className={weeklyStyles["event-title"]}>
              {titleWordLimit(
                event?.agendaType === constants.agendaType.LEAVE
                  ? "On Leave"
                  : event?.agendaType === constants.agendaType.APPOINTMENT
                    ? "Patient Appointment"
                    : event.title,
              )}
            </div>
          )}

        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("assignedEmployees")) &&
          !isDragPreview &&
          (event?.modifiedEmployeeCount > 0 ||
            event?.eventEmployeeCount > 0) && (
            <div
              className="interactive-element"
              onClick={(e) =>
                event?.eventEmployeeCount > 1 &&
                toggleEmpPopup(e, event, dayMoment)
              }
            >
              {event?.modifiedEmployeeCount > 1 ||
              !event?.modifiedEmployeeCount ? (
                <span className="link-btn">
                  {`${event?.modifiedEmployeeCount || 0} Employees`}
                </span>
              ) : (
                <span className="link-btn-without-underline">
                  {event?.eventEmployeeUsers}
                </span>
              )}
            </div>
          )}

        {!isDragPreview &&
          dateFormater(isEmpPopActive?.date) === dateFormater(dayMoment) &&
          isEmpPopActive.id === event.id &&
          ReactDOM.createPortal(
            <div
              ref={popupRef}
              className={styles["employee-popup-box"]}
              style={{
                position: "absolute",
                top: isEmpPopActive.position?.top,
                left: isEmpPopActive.position?.left,
                zIndex: 1050,
                width: "max-content",
              }}
            >
              <span
                className={styles["close-icon"]}
                onClick={(e) => {
                  e.stopPropagation();
                  setEmpPopupActive("");
                }}
              >
                &times;
              </span>
              <div className={styles["emp-data-list"]}>
                {isEmpPopActive?.data?.map((e, __index) => (
                  <div className={styles["emp-data"]} key={__index}>
                    <Row className={styles["row-box"]}>
                      <Text
                        size="14px"
                        color="#587E85"
                        weight="600"
                        paddingLeft="5px"
                      >
                        {e?.user?.firstName} {e?.user?.lastName}{" "}
                      </Text>
                      <div className={styles.clinic_role_status_wrapper}>
                        <Text size="12px" color="#2F3245" weight="500">
                          {e?.office?.name}
                        </Text>
                        <span className={styles.bullet_text}>
                          <Text size="12px" color="#2F3245" weight="500">
                            {e?.user?.role?.systemRole === 2
                              ? e?.user?.role?.name
                                ? e?.user?.role?.name
                                : "--"
                              : e?.user?.designation?.name
                                ? e?.user?.designation?.name
                                : "--"}
                          </Text>
                        </span>
                        <span className={styles.bullet_text}>
                          <p className={styles.status_text}>
                            {t(getSchedulerStatusById(e?.status))}
                          </p>
                        </span>
                      </div>
                    </Row>
                  </div>
                ))}
              </div>
            </div>,
            document.body,
          )}
      </div>
    );
  };

  function updateList(data, type) {
    if (data && (type === "ADD" || type === "EDIT")) {
      const updated = { ...dayData, note: true, data: data.data };
      setDayData(updated);
    }
    if (type === "DELETE") {
      const updated = { ...dayData, note: false };
      delete updated.data;
      setDayData(updated);
    }
  }

  function deleteNotesConfirm() {
    setdeleteConfirmation({ visible: false, id: "" });
    setIsLoading(true);
    deleteSchedularNote(deleteConfirmation.id)
      .then((res) => {
        if (res.statusCode === 200) {
          updateList("", "DELETE");
          toast.success(res?.message);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        toast.error(e.message);
      });
  }

  function addNotesModelShow(data, type) {
    setIsAddNotesModal({
      visible: true,
      data,
      type,
      value: type === "EDIT" ? data.data.text : "",
    });
  }

  function editNotesModelShow(data) {
    setIsEditNotesModal({ visible: true, data });
  }

  function publishedEventConfirm(isPublish) {
    setIsLoading(true);
    eventPublished(eventId.id, isPublish)
      .then((res) => {
        setIsPublishEventModalOpen(false);
        getNotes(currentDate);
        handleSuccess(res.message);
      })
      .catch(handleError)
      .finally(() => setIsLoading(false));
  }

  function clostPublishEventModal() {
    setIsPublishEventModalOpen(false);
    setIsDraftPublishEvetntOpen(false);
  }

  const holidayList = existingHoliday ? [{ title: existingHoliday }] : [];
  const hasHoliday = !!existingHoliday;

  useEffect(() => {
    if (!search || !highlightCheck) return;
    if (divRef.current) {
      setTimeout(() => {
        divRef.current.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center",
        });
      }, 500);
    }
    const timeOut = setTimeout(() => {
      const queryParams = new URLSearchParams(search);
      if (queryParams.has(showTime)) {
        queryParams.delete(showTime);
        history.replace({
          search: queryParams.toString(),
        });
      }
    }, 3000);
    return () => clearTimeout(timeOut);
  }, [search, highlightCheck, history]);

  return (
    <>
      {(isLoading ||
        isEventLoading ||
        isDragDropLoading ||
        isAssignLoading) && <Loader />}

      <div
        className={weeklyStyles["weekly-schedular-calendar-styles"]}
        ref={scrollContainerRef}
        style={{
          maxHeight: tableHeight,
          overflowY: "auto",
          position: "relative",
        }}
      >
        <div
          ref={headerRef}
          className={weeklyStyles["DailyCalendarSchedular_header-row"]}
          style={{
            position: "sticky",
            top: 0,
            zIndex: 105,
            backgroundColor: "#ffffff",
          }}
        >
          <div className={weeklyStyles["time-placeholder"]}></div>
          <div
            className={`${weeklyStyles["day-column-header"]}${
              highlightCheck ? " blinking-background" : ""
            }`}
          >
            <div
              className={`${weeklyStyles["header-top"]} ${weeklyStyles["header-top-daily"]}`}
            >
              <div className={weeklyStyles["daily-header-nav-box"]}>
                <div className={weeklyStyles["daily-header-nav-box-wrapper"]}>
                  {dayData.note && (
                    <div className={weeklyStyles["note-wrapper"]}>
                      <NoteView
                        list={dayData}
                        dateShow={dayMoment.format("ddd, MMM DD, YYYY")}
                      />
                    </div>
                  )}
                  <div className={weeklyStyles["header-nav"]}>
                    <div
                      className="arrow-img cursor-pointer"
                      onClick={() => changeDate("prev")}
                    >
                      <img
                        src={
                          require("assets/images/monthly-arrow-left.svg")
                            .default
                        }
                        alt="icon"
                      />
                    </div>
                    <span className={weeklyStyles["date-text"]}>
                      {dayMoment.format("ddd, MMM DD, YYYY")}
                    </span>
                    <div
                      className="arrow-img cursor-pointer"
                      onClick={() => changeDate("next")}
                    >
                      <img
                        src={
                          require("assets/images/monthly-arrow-right.svg")
                            .default
                        }
                        alt="icon"
                      />
                    </div>
                  </div>

                  <UncontrolledDropdown
                    className={`select-common-dropdown ${weeklyStyles["date-ellipse-menu"]} ${weeklyStyles["min-width-fix"]}`}
                  >
                    <DropdownToggle tag="div" className="cursor-pointer">
                      <ThreeDots color="#9CA3AF" />
                    </DropdownToggle>
                    <DropdownMenu end>
                      <DropdownItem
                        onClick={() =>
                          history.push(constants.routes.scheduler.addEvent, {
                            date: dayMoment.format("YYYY-MM-DD"),
                          })
                        }
                      >
                        <span>
                          {t(
                            canAddShift
                              ? "accountOwner.newEventShift"
                              : "accountOwner.newEvent",
                          )}
                        </span>
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          if (dayData.note) editNotesModelShow(dayData);
                          else addNotesModelShow(dayData, "ADD");
                        }}
                      >
                        <span>
                          {dayData.note
                            ? t("accountOwner.viewNote")
                            : t("staff.addNote")}
                        </span>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* All-day events row (NOT sticky, will scroll) */}
        <div className={weeklyStyles["holiday-row"]}>
          <div
            className={`${weeklyStyles["time-placeholder"]} ${weeklyStyles["daily-time-placeholder"]}`}
          >
            all-day
          </div>
          <div
            className={`${weeklyStyles["holiday-cell"]} ${weeklyStyles["all-day-cell"]}`}
            style={{
              padding: allDayEvents.length > 0 ? "4px" : 0,
              backgroundColor: hasHoliday ? "#e7ecf0" : "transparent",
              cursor: bulkSelectMode ? "default" : "pointer",
            }}
            onDragOver={(e) => handleDragOver(e, 0, true)}
            onClick={(e) => {
              if (bulkSelectMode || isDragging) return;
              if (e.target !== e.currentTarget) return;
              history.push(constants.routes.scheduler.addEvent, {
                date: dayMoment.format("YYYY-MM-DD"),
              });
            }}
          >
            {allDayEvents.map((event, eventIndex) => {
              return (
                <div key={eventIndex} style={{ marginBottom: "4px" }}>
                  {renderEvent(
                    event,
                    {
                      position: "relative",
                      marginBottom: 0,
                      width: "100%",
                    },
                    dayMoment,
                    null,
                    dayMoment.format("ddd, MMM DD, YYYY"),
                  )}
                </div>
              );
            })}
            {!bulkSelectMode && !isDragging && allDayEvents.length === 0 && (
              <EmptySchedulerCellAdd
                variant="circle"
                ariaLabel={t(
                  canAddShift
                    ? "accountOwner.newEventShift"
                    : "accountOwner.newEvent",
                )}
                onClick={() =>
                  history.push(constants.routes.scheduler.addEvent, {
                    date: dayMoment.format("YYYY-MM-DD"),
                  })
                }
              />
            )}
            {/* Drag preview for all-day events */}
            {isDragging &&
              dragPreviewPosition &&
              dragPreviewPosition.isAllDay &&
              draggedEvent &&
              draggedEvent.eventItem && (
                <div
                  style={{
                    marginTop: "4px",
                    pointerEvents: "none",
                    border: "2px dashed #C8E364",
                    borderRadius: 4,
                    overflow: "hidden",
                  }}
                >
                  {renderEvent(
                    draggedEvent.eventItem,
                    {
                      position: "relative",
                      cursor: "grab",
                      width: "100%",
                      marginBottom: 0,
                      opacity: 0.7,
                    },
                    dayMoment,
                    null,
                    null,
                    true,
                  )}
                </div>
              )}
          </div>
        </div>

        {/* Holiday row (NOT sticky, will scroll) */}
        {hasHoliday && (
          <div className={weeklyStyles["holiday-row"]}>
            <div
              className={`${weeklyStyles["time-placeholder"]} ${weeklyStyles["daily-time-placeholder"]}`}
            ></div>
            <div className={weeklyStyles["holiday-cell"]}>
              {holidayList?.length > 0 && (
                <div className={weeklyStyles["holiday-card"]}>
                  <img src={HolidayImage} alt="Holiday" />
                  {holidayList[0]?.title ?? "HOLIDAY"}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Main Body container */}
        <div className={weeklyStyles["body-container"]}>
          <div
            className={`${weeklyStyles["time-labels-column"]} ${weeklyStyles["daily-time-labels-column"]}`}
          >
            {hours.map((h, i) => (
              <div
                key={i}
                className={weeklyStyles["time-slot"]}
                style={{ height: `${HOUR_HEIGHT}px` }}
              >
                <span className={weeklyStyles["time-text"]}>{h.label}</span>
              </div>
            ))}
          </div>

          <div
            ref={highlightCheck ? divRef : undefined}
            className={`${weeklyStyles["day-column-body"]} ${
              existingHoliday ? weeklyStyles["holiday-bg"] : ""
            }${highlightCheck ? " blinking-background" : ""}`}
          >
            {hours.map((h, i) => (
              <div
                key={i}
                className={weeklyStyles["grid-line"]}
                style={{
                  height: `${HOUR_HEIGHT}px`,
                  position: "relative",
                  cursor: bulkSelectMode ? "default" : "pointer",
                }}
                onDragOver={(e) => handleDragOver(e, i, false)}
                onDrop={(e) => handleDrop(e, i)}
                onClick={() => {
                  if (bulkSelectMode || isDragging) return;
                  history.push(constants.routes.scheduler.addEvent, {
                    date: dayMoment.format("YYYY-MM-DD"),
                  });
                }}
              >
                {!bulkSelectMode &&
                  !isDragging &&
                  !hourSlotHasEvent(timeGridEvents, h.hour) && (
                    <EmptySchedulerCellAdd
                      variant="circle"
                      ariaLabel={t(
                        canAddShift
                          ? "accountOwner.newEventShift"
                          : "accountOwner.newEvent",
                      )}
                      onClick={() =>
                        history.push(constants.routes.scheduler.addEvent, {
                          date: dayMoment.format("YYYY-MM-DD"),
                        })
                      }
                    />
                  )}
              </div>
            ))}

            {positionedEvents.map(
              ({ event, widthFactor, leftOffsetFactor }) => {
                const startMin = getTimeInMinutes(event.startTime);
                const endMin = getTimeInMinutes(event.endTime);

                const topPx = (startMin / 1440) * (24 * HOUR_HEIGHT);
                const heightPx =
                  ((endMin - startMin) / 1440) * (24 * HOUR_HEIGHT);

                const dynamicStyles = {
                  top: `${topPx}px`,
                  height: `${Math.max(heightPx, 44)}px`,
                  left: `calc(${leftOffsetFactor * 100}% + 2px)`,
                  width: `calc(${widthFactor * 100}% - 4px)`,
                };

                // Calculate which hour this event starts in
                const eventHour = Math.floor(startMin / 60);

                return renderEvent(
                  event,
                  dynamicStyles,
                  dayMoment,
                  eventHour,
                  dayMoment.format("ddd, MMM DD, YYYY"),
                );
              },
            )}

            {/* Drag preview for time-based events */}
            {isDragging &&
              dragPreviewPosition &&
              !dragPreviewPosition.isAllDay &&
              draggedEvent &&
              draggedEvent.eventItem &&
              dragPreviewPosition.hourIndex !== undefined && (
                <div
                  style={{
                    position: "absolute",
                    top: `${
                      dragPreviewPosition.hourIndex * HOUR_HEIGHT +
                      (dragPreviewPosition.topPercent / 100) * HOUR_HEIGHT
                    }px`,
                    left: 0,
                    width: "100%",
                    height: `${
                      (dragPreviewPosition.heightPercent / 100) * HOUR_HEIGHT
                    }px`,
                    backgroundColor:
                      getEventThemeClass(draggedEvent.eventItem) ===
                      "theme-orange"
                        ? "#fff9eb"
                        : getEventThemeClass(draggedEvent.eventItem) ===
                            "theme-blue"
                          ? "#ebf8ff"
                          : "#C8E36433",
                    border: "2px dashed #C8E364",
                    borderRadius: 6,
                    opacity: 0.6,
                    zIndex: 1000,
                    pointerEvents: "none",
                    display: "flex",
                    alignItems: "center",
                    padding: "2px 4px",
                  }}
                >
                  <div
                    style={{
                      fontSize: 10,
                      color: "#2D3245",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      width: "100%",
                    }}
                  >
                    {titleWordLimit(draggedEvent.eventItem.title || "")}
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>

      {renderMultipleDuplicatesFlyout(onDuplicateEvent, t)}

      <AddNotesModal
        isAddNotesModal={isAddNotesModal}
        setIsAddNotesModal={setIsAddNotesModal}
        updateList={updateList}
        setIsLoading={setIsLoading}
        getDetailsOwnerIfStaff={selectedOwnerId}
      />
      <EditNotesModal
        isEditNotesModal={isEditNotesModal}
        setIsEditNotesModal={setIsEditNotesModal}
        addNotesModelShow={addNotesModelShow}
        setdeleteConfirmation={setdeleteConfirmation}
      />
      <DeleteNotes
        isDeleteEventModalOpen={deleteConfirmation.visible}
        setIsDeleteEventModalOpen={setdeleteConfirmation}
        deleteNotesConfirm={deleteNotesConfirm}
        updateList={updateList}
      />
      {renderSimpleDeleteConfirmModal()}
      <PublishEventModal
        isLoader={isLoading}
        isPublishEventModalOpen={isPublishEventModalOpen}
        noOfEmployeeAssigne={noOfEmployeeAssigne}
        isDraftPublistEventOpen={isDraftPublistEventOpen}
        publishedEventConfirm={publishedEventConfirm}
        clostPublishEventModal={clostPublishEventModal}
      />
      {renderAssignUsersModals()}
      {editModalConfirmation && pendingDragUpdate && (
        <EditOptionsModal
          isOpen={editModalConfirmation}
          closeStepOneModal={setEditModalConfirmation}
          loader={isDragDropLoading}
          eventKey={{
            eventOrShift: t(
              `accountOwner.${
                pendingDragUpdate.eventData?.isShift ? "shift" : "event"
              }Tab`,
            ).toLowerCase(),
          }}
          eventOrShiftTab={pendingDragUpdate.eventData?.isShift || false}
          busySlots={false}
          repeatedOptionChanged={pendingDragUpdate.anyChangedForDate || false}
          handleConfirm={async (value) => {
            setIsDragDropLoading(true);
            try {
              await performEventUpdate(
                pendingDragUpdate.eventData,
                pendingDragUpdate.newDateTime,
                value,
                pendingDragUpdate.originalRequestedDate,
              );
            } catch {
            } finally {
              setEditModalConfirmation(false);
              setPendingDragUpdate(null);
              setIsDragDropLoading(false);
            }
          }}
        />
      )}
    </>
  );
}

export default withTranslation()(EventsShiftsDaily);
